export enum Allergens {
  Wheat = 'WHEAT',
  Fish = 'FISH',
  Misl = 'MILK',
  Eggs = 'EGGS',
  Peanuts = 'PEANUTS',
  SoyBean = 'SOYBEAN',
  TreeNuts = 'TREE_NUTS'
}
